import { DrawingColorPickerComponent } from './drawing-color-picker.component';

export default angular
  .module('sfMobile.components.drawing-color-picker', [])
  .component('sfDrawingColorPicker', DrawingColorPickerComponent).name;
